/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class CoreFormatterKey {
  static readonly DATE = 'kit-core/formatter/date';
  static readonly TIME = 'kit-core/formatter/time';
  static readonly NUMBER = 'kit-core/formatter/number';
  static readonly PERCENT = 'kit-core/formatter/percent';
  static readonly INDENT = 'kit-core/formatter/indent';
  static readonly JOIN = 'kit-core/formatter/join';
}
